module.exports = __webpack_public_path__ + "static/media/turnRight.d4742e39.svg";